<template>
  <v-app>
    <v-navigation-drawer
      absolute
      persistent
      :mini-variant="miniVariant"
      :clipped="clipped"
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      expand-on-hover
    >
      <v-list>
        <template
         v-for="(item, i) in items">
        <v-list-tile
          value="true"
          :key="i"
          @click="switchRoute(item.link)"
          v-if="(item.title == 'Settings' ? hasSettingsPermission : true) 
          && (item.title == 'Dashboard' ? hasDashboardPermission : true)
          && (item.title == 'Buyers' ? hasBuyerPermission : true)
          && (item.title == 'Record' ? hasRecordsPermission : true)
          && (item.title == 'Reports' ? hasReportsPermission : true)
          && (item.title == 'Transactions' ? hasTransactionPermission : true)"          
        >
        <!-- v-if="item.title != 'Settings' || hasSettingsPermission" -->
          <v-list-tile-action>
            <div class="dashboard-item">
              <v-icon v-html="item.icon"></v-icon>
              <span class="dashboard-item-title">{{$t(item.title)}}</span>
            </div>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
      </v-list>

      <!-- GST Reports -->
      <!-- <v-menu top :offset-x="true">
      <template v-slot:activator="{ on }">
          <div class="dashboard-item2" v-on="on">
            <v-icon class="primary--text" v-html="'filter_b_and_w'"></v-icon>
            <span class="dashboard-item-title" style="text-align: center;">GST reports</span>
          </div>
      </template>

      <v-list class="GST_reports">
        <v-list-tile @click="switchRoute('GST1Reports')">
          <v-list-tile-title class="primary--text font-weight-bold">
            GST-1
            <v-icon dark class="primary--text">looks_one </v-icon>
          </v-list-tile-title>
        </v-list-tile>
         <v-list-tile @click="switchRoute('GST3Reports')">
          <v-list-tile-title class="primary--text font-weight-bold">
            GST-3
            <v-icon dark class="primary--text">looks_3 </v-icon>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
      </v-menu>-->
    </v-navigation-drawer>
    <v-toolbar class="primary white--text" app :clipped-left="clipped">
      <v-toolbar-side-icon class="primary white--text" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <!-- <img style="width: 40px;" src="@/assets/logo.png" alt="avatar"> -->
      <v-toolbar-title>{{$t(title)}}</v-toolbar-title>
      <v-spacer />
      <!-- <v-toolbar-title class="primary font-weight-bold">{{getSelectedBrandName}}</v-toolbar-title>
      <v-spacer />  -->

      <!-- Start of Brand Name -->
      <!-- <div class="text-xs-center">
        <v-menu offset-y>
          <v-btn slot="activator" class="font-weight-bold Headline" color="primary" dark>{{getSelectedBrandName}}</v-btn>
            <v-list>
              <v-list-tile v-for="(item, index) in getBrands" :key="index" @click="switchBrand(index)">
                <v-list-tile-title>{{ item }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
        </v-menu>
      </div>-->
      <!-- End of Brand Name -->

      <!-- <router-link v-if="$route.path=='/reports'" to="/montly-stock-reports">
      <v-btn
        flat icon color="white"
        style="margin: 0px 20px;"
      >
      <div class="dashboard-item" style="padding: 0px 30px 0px 30px;">
        <v-icon>list_alt</v-icon>
        <span class="dashboard-item-title" style="color: white;font-size:9px;">Monthly Reports</span>
      </div> 
      
      </v-btn>
      </router-link>-->

      <!-- <router-link to="/ist">
      <v-btn
        flat icon color="white"
        style="margin: 0px 20px;"
      >
        <div class="dashboard-item" style="padding: 0px 30px 0px 30px;">
          <v-icon>account_balance_wallet</v-icon>
          <span class="dashboard-item-title" style="color: white;">ITC</span>
        </div> 
      </v-btn>
      </router-link>-->

      <!-- Start of Transfer -->
      <router-link v-if="$route.path!='/transfer' && hasTransferPermission" to="/transfer">
        <v-btn flat icon color="white" style="margin: 0px 15px;">
          <div class="dashboard-item" style="padding: 0px 20px 0px 20px;">
            <v-icon>mdi-autorenew</v-icon>
            <span class="dashboard-item-title" style="color: white;">{{$t("Transfer")}}</span>
          </div>
        </v-btn>
      </router-link>
      <!-- End of Transfer -->
      
      <img id='pdfimgToExport' src='@/assets/perfectLogo.png' style='display:none'/> 
      <img id='pdfimgToExportHorizontal' src='@/assets/horizontalLogo.png' style='display:none'/> 
      
      <v-btn v-if="hasRatesPermission" flat icon color="white" @click="dialog = true" style="margin: 0px 15px;">
        <div class="dashboard-item" style="padding: 0px 10px 0px 10px;">
          <v-icon>text_snippet</v-icon>
          <span class="dashboard-item-title" style="color: white;">{{$t("Rates")}}</span>
        </div>
      </v-btn>

      <router-link v-if="$route.path!='/products' && hasProductsPermission" to="/products">
        <v-btn flat icon color="white" style="margin: 0px 15px;">
          <div class="dashboard-item" style="padding: 0px 20px 0px 20px;">
            <v-icon>shopping_basket</v-icon>
            <span class="dashboard-item-title" style="color: white;">{{$t("Products")}}</span>
          </div>
        </v-btn>
      </router-link>

      <!-- v-if="$route.path=='/Dashboard'" -->
      <v-btn flat icon color="white" @click="toggleAlertList()" style="margin: 0px 15px;">
        <div class="dashboard-item" style="padding: 0px 20px 0px 20px;">
          <v-icon>alarm_on</v-icon>
          <span class="dashboard-item-title" style="color: white;">{{$t("Alerts")}}</span>
        </div>
      </v-btn>
      

      <!-- Set Rate -->

      <!-- <v-btn flat icon color="white" @click="dialog=true" style="margin: 0px 20px;">
				 <div class="dashboard-item" style="padding: 0px 30px 0px 30px;">
            <v-icon>autorenew</v-icon>
            <span class="dashboard-item-title" style="color: white;">{{$t("Set Rate")}}</span>
          </div>   
      </v-btn> -->

      <!-- <v-spacer></v-spacer>
      <v-btn flat icon color="white" @click="updatePrice">
        <v-icon>autorenew</v-icon>
      </v-btn>-->
      <!-- <v-spacer></v-spacer> -->
      <div class="text-center">
        <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-x  :max-width="400">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="indigo" v-bind="attrs" v-on="on" fab dark>
              <v-icon large>mdi-account-circle</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-card-title primary title class="indigo white--text">
              <!-- <span class="headline">Manage {{getSelectedBrandName}}</span> -->
              <span class="headline">Manage</span>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <div
                    class="dashboard-item"
                    style="padding: 0px 0px;
                    text-align: center;
                    width: 100%;"
                  >
                    <v-icon color="indigo" style="font-size: 110px;">account_box</v-icon>
                    <div>
                      <h3 class="primary--text font-weight-bold headline" style="margin-top: -10px"> {{getSelectedBrandName}} </h3>
                      <h4 class="primary--text font-weight-light subheading"> {{adminEmail}} </h4>
                    </div>
                  </div>
                </v-flex>
                <v-flex xs6>
                  <v-select
                    dense
                    :items="getFinList"
                    label="Financial Year"
                    @change="setFinYear()"
                    :disabled="!hasFinChangePermission"
                    v-model="currentFinancialYear"
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-select
                    :items="langs"
                    @change="changeLocale()"
                    v-model="$i18n.locale"
                    menu-props="auto"
                    class="black-text font-weight-bold"
                    item-text="text"
                    item-value="value"
                    label="Select Language"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    dense
                    :items="firmsByBrand"
                    label="Select Firm"
                    item-text="text"
                    item-value="value"
                    v-model="selectedDefaultFirm"
                    @change="setDefaultFirm(selectedDefaultFirm)"
                    :disabled="!hasFirmChangePermission"
                    clearable
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-card-text>
            
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn primary title class="indigo white--text" flat="flat" @click="signOut">
                <v-icon left>exit_to_app</v-icon>Logout
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-menu>
      </div>
    </v-toolbar>

    <!-- AlertSheet navigation drawer -->
    <v-navigation-drawer
      persistent
      :clipped="clipped"
      v-model="alertListOpen"
      right
      temporary
      enable-resize-watcher
      fixed
      app
    >
      <v-card>
        <v-card-title primary-title class="primary white--text">
          <h3 color="primary">
            <!-- Alert Sheet -->
          </h3>
          <v-switch
            class="custom-alert"
            v-model="alertMode"
            :label="`${alertMode ? 'Product Alert' : 'Customer Alert'}`"
          ></v-switch>
          <v-spacer />
          <v-btn outline dark small @click="alertListOpen = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
      </v-card>
      <v-divider></v-divider>
      <alert-side-bar :alertMode="alertMode" />
    </v-navigation-drawer>

    <!-- Show toggleAlertSheet button when route.path is /Dashboard -->
    <v-content>
      <router-view />
    </v-content>
    <template v-if="dialog">
    <v-dialog
      v-model="dialog"
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
      persistent
      width="700"
    >
      <rate-card :brand="brand" @close="dialog = false" />
    </v-dialog>
    </template>
  </v-app>
  <!-- <v-app v-else>
    <under-maintenance></under-maintenance>
  </v-app> -->
  <!-- v-if="!maintenance" -->
</template>

<script>
import { cfirebase } from "../../services/firebase.js";
import { createNamespacedHelpers } from "vuex";
import  permissionObj from '../../utils/permissins'


import RateCard from "./RateCard";
import AlertSideBar from "./AlertSidebar";
import UnderMaintenance from "./../UnderMaintenance/UnderMaintenance.vue";

let brand = window.localStorage.getItem('brand');
//let brandFinYear = window.localStorage.getItem('brandFinYear');
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapGlobalActions = createNamespacedHelpers("Global")["mapActions"];
export default {
  data() {
    return {
      maintenance : true,
      dialog: false,
      menu : null,
      selectedDefaultFirm: null,
      previousDafaultFirm: null,
      langs: [{text:'English',
      value:'en'
      },{text : 'हिन्दी',
      value : 'hi'}],
      // currentFinancialYear: new Date().getFullYear() + "-" + ((new Date().getFullYear() + 1) % 100),
      currentFinancialYear:this.getCurrentFinYear(),
      clipped: true,
      alertMode: false,
      drawer: false,
      fixed: true,
      items: [
        {
          icon: "dashboard",
          title: "Dashboard",
          link: "/",
        },
        {
          icon: "people",
          title: "Buyers",
          link: "Buyers",
        },
        {
          icon: "list_alt",
          title: "Record",
          link: "Reports",
        },
        {
          icon: "swap_horiz",
          title: "Transactions",
          link: "InvoiceManagement",
        },
        {
          icon: "settings",
          title: "Settings",
          link: "Settings",
        },
        {
          icon: "report",
          title: "Reports",
          link: "Informations",
        },
          // },{
          //   icon: 'report',
          //   title: 'GSTReports',
          //   link: 'GSTReports'
          // {
          //   icon: "list_alt",
          //   title: "Godown Reports",
          //   link: "GodownReports",
          // },
      ],
      miniVariant: true,
      right: true,
      title: "Acuify",
      alertListOpen: false,
      brands: [],
      operators: [],
    };
  },
  name: "Home",
  components: {
    RateCard,
    AlertSideBar,
    UnderMaintenance,
  },
  created() {
    this.setBrand();
    this.$bindAsObject("brands", this.$root.$firebaseRefs.brand);
    this.$bindAsObject("operators", this.$root.$firebaseRefs.operator);
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(brand))
    this.$bindAsArray("brandPermission", this.$root.$firebaseRefs.brandPermission.orderByChild('brand').equalTo(brand))
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand","adminEmail","roleAndPermission"]),
    ...mapGlobalGetters({
      allBrands: "brands",
    }),
    hasSettingsPermission(){
      if(this.roleAndPermission && 
      this.roleAndPermission.permissions && 
      this.roleAndPermission.permissions.length && 
      this.roleAndPermission.permissions.indexOf('BRAND_SETTINGS')>-1) {
        return true;
      } else {
        return false;
      }
    },
    hasRecordsPermission(){
      if(this.roleAndPermission && 
      this.roleAndPermission.permissions && 
      this.roleAndPermission.permissions.length && 
      this.roleAndPermission.permissions.indexOf('BRAND_RECORDS')>-1) {
        return true;
      } else {
        return false;
      }
    },
    hasReportsPermission(){
      if(this.roleAndPermission && 
      this.roleAndPermission.permissions && 
      this.roleAndPermission.permissions.length && 
      this.roleAndPermission.permissions.indexOf('BRAND_REPORTS')>-1) {
        return true;
      } else {
        return false;
      }
    },
    hasTransactionPermission(){
      if(this.roleAndPermission && 
      this.roleAndPermission.permissions && 
      this.roleAndPermission.permissions.length && 
      this.roleAndPermission.permissions.indexOf('BRAND_TRANSACTIONS')>-1) {
        return true;
      } else {
        return false;
      }
    },
    hasDashboardPermission(){
      if(this.roleAndPermission && 
      this.roleAndPermission.permissions && 
      this.roleAndPermission.permissions.length && 
      this.roleAndPermission.permissions.indexOf('BRAND_DASHBOARD')>-1) {
        return true;
      } else {
        return false;
      }
    },
    hasBuyerPermission(){
      if(this.roleAndPermission && 
      this.roleAndPermission.permissions && 
      this.roleAndPermission.permissions.length && 
      this.roleAndPermission.permissions.indexOf('BRAND_BUYER')>-1) {
        return true;
      } else {
        return false;
      }
    },
    hasRatesPermission(){
      if(this.roleAndPermission && 
      this.roleAndPermission.permissions && 
      this.roleAndPermission.permissions.length && 
      (this.roleAndPermission.permissions.indexOf('SALE_RATE_VIEW_EDIT')>-1 || this.roleAndPermission.permissions.indexOf('PURCHASE_RATE_VIEW_EDIT')>-1)) {
        return true;
      } else {
        return false;
      }
    },
    hasProductsPermission(){
      if(this.roleAndPermission && 
      this.roleAndPermission.permissions && 
      this.roleAndPermission.permissions.length && 
      this.roleAndPermission.permissions.indexOf('BRAND_PRODUCTS')>-1)  {
        return true;
      } else {
        return false;
      }
    },
    hasTransferPermission(){
      if(this.roleAndPermission && 
      this.roleAndPermission.permissions && 
      this.roleAndPermission.permissions.length && 
      this.roleAndPermission.permissions.indexOf('AMOUNT_TRANSFER')>-1) {
        return true;
      } else {
        return false;
      }
    },
    hasFirmChangePermission(){
      if(this.roleAndPermission && 
      this.roleAndPermission.permissions && 
      this.roleAndPermission.permissions.length && 
      this.roleAndPermission.permissions.indexOf('CHANGE_DEFAULT_FIRM')>-1) {
        return true;
      } else {
        return false;
      }
    },
    hasFinChangePermission(){
      if(this.roleAndPermission && 
      this.roleAndPermission.permissions && 
      this.roleAndPermission.permissions.length && 
      this.roleAndPermission.permissions.indexOf('CHANGE_FIN_YEAR')>-1) {
        return true;
      } else {
        return false;
      }
    },
    firmsByBrand() {
      if(this.selectedBrand) {
        return this.firms
        .filter((item) => item["brand"] == brand)
        .map((item) => {
          if (item.defaultFirm) {
            console.log(item);
            this.selectedDefaultFirm = item[".key"];
            this.previousDafaultFirm = item[".key"];
          }
          return {
            text: item["name"],
            value: item[".key"],
          };
        });
      } else {
        return [];
      }
    },
    getFinList() {
      let finList = [];
      for (let i = -10; i < 10; i++) {
        finList.push(
          new Date().getFullYear() +
            i +
            "-" +
            ((new Date().getFullYear() + (i + 1)) % 100)
        );
      }
      return finList;
    },
    getBrands() {
      console.log(0, this.brands);
      if (this.brands && this.getUserBrands) {
        // console.log(1)
        let result = {};
        for (let key in this.brands) {
          if (this.getUserBrands.indexOf(key) !== -1) {
            result[key] = this.brands[key];
          }
        }
        return result;
      }
      return {};
    },
    getUserBrands() {
      if (this.operators) {
        let data = Object.keys(this.operators).filter((key) => {
          return this.operators[key]["uid"] === this.getUserId;
        });
        if (data) {
          if (this.operators[data[0]]) {
            this.setRolesAndPermission(this.operators[data[0]]);
            return this.operators[data[0]]["brand"];
          }
        }
      }
      return [];
    },
    getUserId() {
      return window.localStorage.getItem("user") || null;
    },
    getSelectedBrandName() {
      if (this.selectedBrand && this.allBrands) {
        // let key = Object.keys(this.selectedBrand)[0]
        // return this.selectedBrand[key]
        return this.allBrands[this.selectedBrand];
      }
    },
  },
  watch: {
    getBrands(val) {
      if (!this.selectedBrand || !Object.keys(val).length) {
        let keys = Object.keys(val);
        //this.SET_SELECTED_BRAND(keys[0]);
        this.setAdminEmail();
        if (this.currentFinancialYear) {
          this.setFinYear();
        }
      }
      this.SET_BRANDS(val);
    },
    // selectedDefaultFirm: {
    //   handler(newVal, oldVal) {
    //     this.setDefaultFirm(newVal);
    //   },
    //   deep: true,
    // },
    $route(to, from) {
      // close the alert sheet when route is changed;
      this.alertListOpen = false;
    },
  },
  methods: {
    ...mapGlobalActions([
      "SET_SELECTED_BRAND",
      "SET_BRANDS",
      "SET_ADMIN_EMAIL",
      "SET_FIN_YEAR",
      "SET_ROLE_AND_PERMISSIONS",
      "SET_BRAND_FIN_YEAR"
    ]),
    changeLocale(){
      window.localStorage.setItem("locale",this.$i18n.locale)
    },
    getCurrentFinYear(){
      // let finYear = window.localStorage.getItem('finYear');
      // if(!finYear) {
        let todayDate = new Date();
        // var from = new Date(0, 1, 2000);
        // var to   = new Date(2, 31, 2000);
        // var check = new Date(todayDate.getMonth(), todayDate.getDate(), 2000);
        // if(check > from && check < to) {
        var finChanginingDate   = new Date(2000,2,31).getTime();
        var check = new Date(2000,todayDate.getMonth(), todayDate.getDate()).getTime();
        if(finChanginingDate >= check) {  
          return  (new Date().getFullYear()-1) + "-" + (new Date().getFullYear() % 100)
        } else {
          return  new Date().getFullYear() + "-" + ((new Date().getFullYear()+1) % 100)
        }
      // }
      // return finYear;
    },
    setRolesAndPermission(user){
      if(user.role) {
        let obj = {
          role: user.role,
          permissions : user.role != 'admin' ? user.permission : permissionObj.PERMISSIONS,
        }
        if(user.role != 'admin') {
          obj['branch'] =  user.branch
        }
        this.SET_ROLE_AND_PERMISSIONS(obj);
        setTimeout(() => {
          let brandPermissions = this.brandPermission.filter(item => item['brand'] == brand);
          if(brandPermissions && brandPermissions.length){
            if(brandPermissions[0].active) {
              obj['brandPermissions'] = brandPermissions[0].permissions;
              this.SET_ROLE_AND_PERMISSIONS(obj);
            } else {
              alert("Sorry! Your Brand is not Active. Please contact Acuify Administrator.");
              cfirebase.auth().signOut();
              this.$router.go("/login");
            }
          }
        }, 3000);
      }
    },
    signOut() {
      // window.localStorage.removeItem('user')
      console.log("Signing Out");
      cfirebase.auth().signOut();
      this.$router.go("/login");
    },
    setAdminEmail() {
      return cfirebase.auth().onAuthStateChanged((user) => {
        this.SET_ADMIN_EMAIL(user.email);
      });
    },
    setFinYear() {
      var start = new Date();
      start.setHours(0, 0, 0, 0);
      start.setYear(this.currentFinancialYear.substring(0, 4));
      start.setMonth(3);
      start.setDate(1);

      var end = new Date();
      end.setHours(23, 59, 59, 999);
      end.setYear("20" + this.currentFinancialYear.substring(5, 7));
      end.setMonth(2);
      end.setDate(31);

      let finYearObj = {
        finYear: this.currentFinancialYear,
        start: start,
        end: end,
      };

      this.SET_FIN_YEAR(finYearObj);
      // window.localStorage.setItem('finYear', this.currentFinancialYear)
      // if(this.selectedBrand) {
      //   this.SET_BRAND_FIN_YEAR(this.selectedBrand + "_" + this.currentFinancialYear);
      //    window.localStorage.setItem('brandFinYear', (this.selectedBrand + "_" + this.currentFinancialYear))
      // }
      // if(isRelaod) {
      //   setTimeout(() => {
      //     location.reload();
      //   }, 1000);
      // }      
    },
    // switchBrand(key) {
    //   if (this.getBrands) {
    //     this.SET_SELECTED_BRAND(key);
    //   }
    // },
    switchRoute(link) {
      console.log(link);
      this.$router.push({ name: link });
      // this.$router.push(`buyer/${link}`)
    },
    toggleAlertList() {
      this.alertListOpen = !this.alertListOpen;
    },
    setBrand(){
      // let brand  = window.localStorage.getItem("brand") || null;
      // this.SET_SELECTED_BRAND(brand);
    },
    setDefaultFirm(newDefaultFirm) {
      this.firmsByBrand.map((item)=>{
        this.$root.$firebaseRefs.firm.child(item.value).update({
        defaultFirm: false
        }, () => {
          console.info('default remove completed...')
        })
      })  
        this.$root.$firebaseRefs.firm.child(newDefaultFirm).update({
          defaultFirm: true
          }, () => {
            console.info('default add completed...')
           this.previousDafaultFirm = newDefaultFirm;
        })
    },
    // setDefaultFirm(newDefaultFirm) {
    //   let defaultFirms = this.firms.filter(
    //     (item) => item.brand == this.selectedBrand && item.defaultFirm == true
    //   );
    //   console.log(defaultFirms);
    //   defaultFirms.map((firm) => {
    //     let key = firm[".key"];
    //     delete firm[".key"];
    //     delete firm["defaultFirm"];

    //     this.$root.$firebaseRefs.firm.child(key).set(firm);
    //   });
    //   let defaultFirmOnly = this.firms.filter(
    //     (item) => item[".key"] == newDefaultFirm
    //   )[0];
    //   delete defaultFirmOnly[".key"];
    //   defaultFirmOnly["defaultFirm"] = true;
    //   this.$root.$firebaseRefs.firm.child(newDefaultFirm).set(defaultFirmOnly);
    // },
  },
};
</script>

<style scoped>
.dashboard-item {
  width: 72px;
  padding: 16px 0 14px;
  outline: 0;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.dashboard-item2 {
  width: 100%;
  outline: 0;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  font-size: 12px;
}
.dashboard-item-title {
  font-size: 11px;
  color: #01579b;
  font-weight: bold;
}
.GST_reports v-list-item {
  padding: 10px 40px;
}
.GST_reports v-list-item-title {
  cursor: context-menu;
}
</style>
<style>
.custom-alert .theme--light.v-label {
  color: white;
}

.custom-alert .v-input--switch__track {
  color: rgba(255, 255, 255, 0.38);
}

.custom-alert .v-input__slot {
  margin-bottom: 0px !important;
}

.custom-alert.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}

.apexcharts-toolbar {
  z-index: 7;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/index.vue